import HeroHomeTemplateFullBackground from './heroHomeTemplateFullBackground/heroHomeTemplate';
import HeroHomeTemplateDefault from './heroHomeTemplateDefault/heroHomeTemplate';
import HeroHomeTemplateEggshell from './heroHomeTemplateEggshell/heroHomeTemplate';

function HeroHomeTemplate({ type, ...rest }) {
  switch (type) {
    case 'Full Width Background Image':
      return <HeroHomeTemplateFullBackground {...rest} />;
    case 'Flat Eggshell Background':
      return <HeroHomeTemplateEggshell {...rest} />;
    default:
      return <HeroHomeTemplateDefault {...rest} />;
  }
}

export default HeroHomeTemplate;
